import { createSelector } from 'reselect';
import { MESSAGING_ACCESS } from '../../constants/Scopes';
import { getScopes } from './getScopes';
export const getHasMessagingAccess = createSelector(getScopes, scopes => scopes.includes(MESSAGING_ACCESS));